
import React from 'react';
import { logger } from '@/utils/logger';

export const LoadingPage: React.FC<{message?: string}> = ({ message = "Loading application..." }) => {
  logger.info("Rendering LoadingPage component");
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-700">{message}</h2>
        <p className="text-sm text-gray-500 mt-2">This should disappear in a few seconds...</p>
      </div>
    </div>
  );
};

export default LoadingPage;
